export default {
      id: "icon-compass-usage",
      viewBox: "0 0 66 66",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-compass",
      toString: function () {
        return this.url;
      }
    }